import { Spinner } from "@blueprintjs/core";
import { ReactPlayerErrorBoundaryRetry } from "@package/ui-apollo-components";
import { useSelectorWall } from "@package/ui-redux";
import { useEffect, useState } from "react";
import { useWallProvider } from "../../context/context-wall/context-wall";

export function BackgroundMediaContent() {
  const background = useSelectorWall((state) => state.wall.background);
  const provider = useWallProvider();
  const [url, setUrl] = useState<string | undefined>();

  useEffect(
    function effectFetchMediaUrl() {
      const fetchMediaUrl = async () => {
        if (background.active) {
          if (background.media?.id) {
            const url = await provider?.fetchMediaUrl(background.media.id);
            if (url) {
              setUrl(url);
              return;
            }
          }

          console.error("Background media has no URL, completing video.");
          provider?.onBackgroundMediaVideoCompleted();
        }
      };

      fetchMediaUrl();

      return () => {
        setUrl(undefined);
      };
    },
    [background.active, background.media?.id, provider],
  );

  if (background.active) {
    if (!url) {
      return (
        <div className="w-full h-full flex flex-col items-center justify-center">
          <Spinner size={100} />
        </div>
      );
    }

    if (background.type === "image") {
      return <img width="100%" height="100%" src={url} />;
    }

    return (
      <ReactPlayerErrorBoundaryRetry
        width="100%"
        height="100%"
        loop={background.loop}
        muted={!background.audio}
        playing
        pip={false}
        url={url}
        onEnded={() => provider?.onBackgroundMediaVideoCompleted()}
        onErrorEvent={(error) => {
          provider?.onBackgroundMediaVideoCompleted();
          console.error("Background media video error:", error);
        }}
        onMediaStalled={() => {
          provider?.onBackgroundMediaVideoCompleted();
          console.error("Background media video stalled, completing video.");
        }}
      />
    );
  }

  return null;
}

export function BackgroundMedia() {
  return (
    <div className="absolute left-0 top-0 h-full w-full z-0 overflow-hidden">
      <BackgroundMediaContent />
    </div>
  );
}
